import { Route, Routes } from 'react-router-dom';

import InventoryValueList from "../../../InventoryValues/InventoryValueList";
import EditInventoryValue from "../../../InventoryValues/EditInventoryValue";

import styled from '@emotion/styled';

import { Grid } from '@mui/material';

const Container = styled.div`
  margin-top: 1.5rem;
`;

const InventoryValues = () => {
  return (
    <Container>
      <Routes>
        <Route path="/colors" element={<InventoryValueList category="colors" />} />
        <Route path="/colors/edit/:id" element={<EditInventoryValue category="colors" />} />
        <Route path="/colors/edit" element={<EditInventoryValue category="colors" />} />
      </Routes>
    </Container>
  );
};

export default InventoryValues;